import { useMemo } from 'react';
import { concat } from 'lodash';

import {
  GroupedOptions,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import useFiles from '@/modules/tasks/views/TasksDashboard/hooks/useFiles';
import { FileCategoryEnum, FilePurposeEnum, FileSubCategoryEnum } from '@/types/schema';

import { getFilesFilterOption } from '../utils';

export interface UseFilesOptionsQueryParams {
  excludeSystemGenerated?: boolean;
  purpose?: FilePurposeEnum[];
  categories?: FileCategoryEnum[];
  subCategories?: FileSubCategoryEnum[];
  hasStages?: boolean;
  notFileIds?: string[];
}

const useFilesOptionsQuery = ({
  excludeSystemGenerated,
  purpose,
  categories,
  subCategories,
  hasStages,
  notFileIds,
  searchText,
}: UseFilesOptionsQueryParams & UseOptionsQueryParams): UseOptionsQueryReturnType => {
  const { files, systemGeneratedFiles, error, isLoading, fetchMore, isFetchingMore } = useFiles({
    filters: {
      name: searchText,
      purpose,
      categories,
      subCategories,
      hasStages,
      notInIds: notFileIds,
    },
  });

  const groups = useMemo((): GroupedOptions[] => {
    const fileOptions = files?.map(getFilesFilterOption) || [];
    let filteredSystemGeneratedFiles = systemGeneratedFiles ?? [];

    const systemGeneratedFileOptions = excludeSystemGenerated
      ? []
      : filteredSystemGeneratedFiles.map(getFilesFilterOption);

    return [
      {
        id: 'FILES',
        options: concat(systemGeneratedFileOptions, fileOptions),
      },
    ];
  }, [excludeSystemGenerated, files, systemGeneratedFiles]);

  return {
    error,
    groups,
    fetching: isLoading || isFetchingMore,
    fetchMore,
  };
};

export default useFilesOptionsQuery;
